import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MenuService } from '../menu.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-menu-button',
  templateUrl: './menu-button.component.html',
  providers: [MenuService],
  imports: [MatIconModule, MatButtonModule, MatIconModule],
})
export class MenuButtonComponent {
  private readonly menuService = inject(MenuService);

  toggleSidenav(): void {
    this.menuService.toggleMenu();
  }
}
